import { buildPrnDetailRows } from "./emarPrnUtils";
import { buildProtocolAssessmentRows } from "./emarProtocolUtils";

const normalizeText = (value: any) => String(value || "").trim();
const normalizeStatus = (value: any) => normalizeText(value).toLowerCase();

export const buildEmarEntryDetailRows = (entry: any, medicationLike?: any) => {
  const rows: Array<{ label: string; value: string }> = [];
  const status = normalizeStatus(entry?.status);
  const note = normalizeText(entry?.note);

  if (note) {
    let label = "Note";
    if (status === "prn_given" || status === "family" || status === "given") {
      label = "Administration note";
    } else if (["refused", "held", "not_given", "missed", "hospitalized"].includes(status)) {
      label = "Reason";
    }
    rows.push({ label, value: note });
  }

  if (status === "prn_given") {
    rows.push(...buildPrnDetailRows(entry));
  }

  rows.push(...buildProtocolAssessmentRows(entry, medicationLike));

  return rows;
};
